// Bearer tokens for Sweep's API client.
//
// Sweep's axios instance has request interceptors, which run outside any
// component, so it cannot use the `useAuth()` composable. main.ts registers the
// Auth0 client's getter here at start-up; the precedence below mirrors
// composables/useAuth.ts: an active impersonation token wins, then Auth0, then
// a stored dev-login token.
import { isTokenExpired } from '@/utils/authErrorHandler'

type Getter = () => Promise<string | undefined | null>

let auth0Getter: Getter | null = null

/** Called once from main.ts with the Auth0 client's getAccessTokenSilently. */
export function setSweepTokenProvider(getter: Getter) {
    auth0Getter = getter
}

export async function getSweepToken(): Promise<string | null> {
    const impersonation = localStorage.getItem('impersonation_token')
    if (impersonation && !isTokenExpired(impersonation)) return impersonation

    if (auth0Getter) {
        try {
            const token = await auth0Getter()
            if (token) return token
        } catch {
            // Not signed in through Auth0 — fall through to the dev token.
        }
    }

    return localStorage.getItem('dev_login_token')
}
